import React, { useEffect, useState } from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import BreadCrumb, { Page } from '../../components/BreadCrumb';
import { useDispatch, useSelector } from 'react-redux';
import { setSelectedPaymentMethod } from '../../store/contract/actions';
import { getDealState, getNegotiationDetails } from '../../store/negotiation/actions';
import { navigationUrl } from '../../store/analytic/actions';
import {
  PaymentCard,
  SelectContainer,
  IconBarCode,
  IconPix,
  Wrapper,
  Container2,
  IconBack,
  SubWrapper,
  Title,
  TitleWrapper,
  Subtitle2,
  Button,
  IconCreditCard,
  LoaderDiv,
} from './styles';
import Loader from 'react-spinners/ClipLoader';
import Loading from '../../components/Loading';

type NegotiationProps = {
  contract: GQL.IDebt;
};

const getIcon = (icon: string) => {
  switch (icon) {
    case 'pix':
      return <IconPix />;
    case 'boleto':
      return <IconBarCode />;
    case 'cartão':
      return <IconCreditCard />;
    default:
      return;
  }
};

type PaymentMethodsType = {
  icon: string;
  text: string;
  code: number;
  analyticsRoute: string;
  visible: boolean;
};

const PaymentMethods = () => {
  const history = useHistory();
  const dispatch = useDispatch();

  const location = useLocation<NegotiationProps>();
  const contract: GQL.IDebt = location.state && location.state.contract;

  const { selectedPaymentMethod } = useSelector((state: ApplicationState) => ({
    selectedPaymentMethod: state.contract.selectedPaymentMethod,
  }));
  const config = useSelector((state: ApplicationState) => state.config);

  const [paymentMethodList, setPaymentmMethodList] = useState<PaymentMethodsType[]>(
    []
  );

  const {
    selectedInstallments,
    listDealOptions,
    negotiationLoading,
  } = useSelector((state: ApplicationState) => ({
    selectedInstallments: state.contract.selectedInstallments,
    listDealOptions: state.negotiation.list,
    negotiationLoading: state.negotiation.negotiationLoading,
  }));

  useEffect(() => {
    if (contract) {
      dispatch(
        getNegotiationDetails.request({
          databaseId: contract.databaseId,
          contract: contract.contracts,
          creditorId: contract.creditorId,
          installmentId: selectedInstallments,
          dealId: contract.dealId,
          paymentType: 0,
        })
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    dispatch,
    contract,
    history,
    selectedInstallments,
  ]);

  useEffect(() => {
    const list = [
      {
        icon: 'pix',
        text: 'Pagar com PIX',
        code: 1,
        analyticsRoute: '/simulouPix ',
        visible: config.usaPix === 'true' && listDealOptions.filter(option => option.paymentMethod === 'Pix').length > 0
      },
      {
        icon: 'boleto',
        text: 'Pagar com Boleto',
        code: 0,
        analyticsRoute: '/simulouBoleto ',
        visible: config.usaDownloadBoleto === 'true' && listDealOptions.filter(option => option.paymentMethod === 'Boleto').length > 0
      },
      {
        icon: 'cartão',
        text: 'Pagar com Cartão de crédito',
        code: 2,
        analyticsRoute: '/simulouCartaoDeCredito',
        visible: config.usaPagamentoCartaoCredito === 'true' && listDealOptions.filter(option => option.paymentMethod === 'CartaoDeCredito').length > 0
      },
    ];
    setPaymentmMethodList(list)
  }, [config, listDealOptions])


  const handleNavigation = (action: string) => {
    if (action === 'previous') {
      return contract?.dealId
        ? history.replace({
          pathname: '/parcela-acordo',
          state: { agreement: contract },
        })
        : history.goBack();
    }
    dispatch(
      navigationUrl.request({
        action: paymentMethodList.find(
          (method) => method.code === selectedPaymentMethod
        )?.analyticsRoute as string,
      })
    );
    history.push({ pathname: '/resumo-acordo', state: { contract } });
  };

  useEffect(() => {
    handleNavigation('next')
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const handleSelectedPaymentMethod = (paymentMethodCode: number) => {
    dispatch(setSelectedPaymentMethod(paymentMethodCode));
  };

  useEffect(() => {
    dispatch(getDealState.success([]));
    dispatch(
      navigationUrl.request({
        action: '/metodosPagamento',
      })
    );
  }, [dispatch]);

  const breadcrumbPreviousPages: Page[] = [
    {
      name: 'Débitos e Acordos',
      route: '/contrato',
      method: 'replace',
    },
    {
      name: contract?.dealId ? 'Meu Acordo' : 'Minhas Faturas',
      route: contract?.dealId ? '/parcela-acordo' : '/faturas',
      state: { agreement: contract },
      method: 'replace',
    },
  ];

  const breadcrumbProps = {
    currentPage: 'Pagamento',
    previouPages: breadcrumbPreviousPages,
    showBreadCrumbOnMinWidth: '960px',
    ...(contract?.dealId && {
      onNavigateBackTo: (index: number) => {
        const page = breadcrumbPreviousPages[index];
        history.replace(page.route, page.state);
      },
    }),
  };

  return (
    <Wrapper>
      <Container2>
        <TitleWrapper>
          <IconBack onClick={() => history.goBack()} />
          <Title>Pagamento</Title>
          <BreadCrumb {...breadcrumbProps} />
        </TitleWrapper>
        <SubWrapper>
          <Subtitle2>Escolha uma opção de pagamento abaixo</Subtitle2>
          {negotiationLoading ?
              <LoaderDiv>
                <Loader />
              </LoaderDiv>
            :
            paymentMethodList.map((method) => (
              method.visible && (
                <PaymentCard
                  key={method.code}
                  onClick={() => handleSelectedPaymentMethod(method.code)}
                >
                  <span className='icon'>{getIcon(method.icon)}</span>
                  <p className='text'>{method.text}</p>
                  <SelectContainer selected={method.code === selectedPaymentMethod}>
                    <span />
                  </SelectContainer>{' '}
                </PaymentCard>
              )
            ))}
        </SubWrapper>
        <div className='footer'>
          <Button color='white' onClick={() => handleNavigation('previous')}>
            Voltar
          </Button>
          <Button
            color='primary'
            onClick={() => handleNavigation('next')}
            disabled={selectedPaymentMethod === null}
          >
            Próximo
          </Button>
        </div>
      </Container2>
    </Wrapper>
  );
};

export default PaymentMethods;
